import Vue from 'vue'

import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode:'history',
    base: '/meetingRoom',
    subBase:'',
  routes: [
    {path: '/',name: 'root',redirect:'/rooms'},
	  {path: '/home',name: 'home',component: ()=>import('./Home.vue')},
	  {path: '/refresh',name: 'refresh',component: ()=>import('../../components/refresh.vue')},
    {path: '/userMenu',name:'userMenu',component: ()=>import('../user/userMenu.vue')},
    {path: '/userMenuItem/:item',name:'userMenuItem',component:()=>import('../user/userMenu.vue')},
    {path: '/rooms',name: 'rooms',component: ()=>import('./rooms.vue')},
    {path: '/rooms/:q',name:'roomsQuery',component:()=>import('./rooms.vue')},
    {path: '/meetingRoomDetail/:id',name:'meetingRoomDetail',component:()=>import('./meetingRoomDetail.vue')},
    {path: '/appointment/:id',name:'appointment',props:true,component: ()=>import('../../components/appointment.vue')},
    {path: '/cmsChannel/:channelId',name:'cmsChannel',component:()=>import('./cmsContent.vue')},
    {path: '/cmsContent/:contentId',name:'cmsContent',component:()=>import('./cmsContent.vue')},
    {path: '*',name: 'default',redirect:'/'},
  ]
})
